import React, {Component} from 'react'
import {connect} from 'react-redux'
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux'
import { actions as authenticationActions } from '../actions/authentication'

import MessageBannerPage from './MessageBannerPage'

import {MessageBannerType} from '@amzn/stencil-react-components/message-banner'

class OAuthCallbackV2 extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var searchParams = new URLSearchParams(window.location.search)

    this.props.actions.authentication.oAuthAthenticate(searchParams.get("code"),searchParams.get("state"))
  }

  render() {
    const { t, auth } = this.props;

    if (!auth.error) {
      return null;
    }

    const message = {
      type: MessageBannerType.Warning,
      value: t(`OAuthCallback.error_${auth.error}`)
    };

    return (
      <MessageBannerPage
        message={message}
      />
    );
  }
}

const mapState = (state) => ({
  auth: state.auth
});

const mapDispatchToProps = (dispatch) => ({
  actions: {
    authentication: bindActionCreators(authenticationActions, dispatch),
  }
});

export default connect(mapState, mapDispatchToProps)(withTranslation('translations')(OAuthCallbackV2));
